import { Fragment } from 'react';
import { useHlsContext } from "../../../context/Hls";
import { useSubtitleContext } from "../../../context/Subtitle";
import { useTranslation } from "../../../hooks";
import Submenu from "./Submenu";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var CC = function CC(_ref) {
  var onSubtitlesChange = _ref.onSubtitlesChange,
    onAudioChange = _ref.onAudioChange;
  var _useHlsContext = useHlsContext(),
    audios = _useHlsContext.audios,
    currentAudio = _useHlsContext.currentAudio;
  var _useSubtitleContext = useSubtitleContext(),
    subtitleOptions = _useSubtitleContext.subtitleOptions,
    currentSubtitleLang = _useSubtitleContext.currentSubtitleLang;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [subtitleOptions && /*#__PURE__*/_jsx(Submenu, {
      title: t('SUBTITLES'),
      options: subtitleOptions,
      selectedValue: currentSubtitleLang ? currentSubtitleLang.value : undefined,
      onSelect: onSubtitlesChange,
      isCCSubmenu: true
    }), subtitleOptions && audios && audios.length > 1 && /*#__PURE__*/_jsx("div", {
      className: "bg-gray-dark opacity-50 mx-24",
      style: {
        width: '1px'
      }
    }), audios && audios.length > 1 && /*#__PURE__*/_jsx(Submenu, {
      title: t('AUDIO'),
      options: audios,
      selectedValue: currentAudio ? currentAudio.value : undefined,
      onSelect: onAudioChange,
      isCCSubmenu: true
    })]
  });
};
export default CC;